/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCurrencyFromJSON, ApiCurrencyToJSON, } from './ApiCurrency';
import { ApiDomainInputFromJSON, ApiDomainInputToJSON, } from './ApiDomainInput';
import { ApiPlatformFromJSON, ApiPlatformToJSON, } from './ApiPlatform';
import { ApiStatusFromJSON, ApiStatusToJSON, } from './ApiStatus';
export function ApiProjectInputFromJSON(json) {
    return ApiProjectInputFromJSONTyped(json, false);
}
export function ApiProjectInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currency': !exists(json, 'currency') ? undefined : ApiCurrencyFromJSON(json['currency']),
        'domains': !exists(json, 'domains') ? undefined : (json['domains'].map(ApiDomainInputFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'overview': !exists(json, 'overview') ? undefined : json['overview'],
        'platform': !exists(json, 'platform') ? undefined : ApiPlatformFromJSON(json['platform']),
        'status': !exists(json, 'status') ? undefined : ApiStatusFromJSON(json['status']),
        'syncEveryHours': !exists(json, 'syncEveryHours') ? undefined : json['syncEveryHours'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
    };
}
export function ApiProjectInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currency': ApiCurrencyToJSON(value.currency),
        'domains': value.domains === undefined ? undefined : (value.domains.map(ApiDomainInputToJSON)),
        'name': value.name,
        'overview': value.overview,
        'platform': ApiPlatformToJSON(value.platform),
        'status': ApiStatusToJSON(value.status),
        'syncEveryHours': value.syncEveryHours,
        'timezone': value.timezone,
    };
}
